import React from 'react';
import { Heading, SubHeading } from '../../typography';
import { Container, HeaderContainer, HeaderImg, Tabs } from './ProductsHeader.style';

const ProductsHeader = () => {
  return (
    <Container>
      <HeaderContainer>
        <Heading fontSize={40}>Advertising Options, Products &amp; Consultancy</Heading>
        <SubHeading fontSize={24} fontWeight="400">
          View our range of agent and developer products and marketing options to help enhance your brand and get your
          listings seen by more people.
        </SubHeading>
      </HeaderContainer>
      <Tabs />
      <HeaderImg />
    </Container>
  );
};

export default ProductsHeader;
